export const PLPLINKLIST = [
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0317S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0317S/-preBtn__2/':
        '総合化学メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_oc__0107M/-preBtn__3/':
        '原料・素材・化学製品営業（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0107M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0317S/-preBtn__2/':
        '総合化学メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_oc__0107M/-preBtn__3/':
        '原料・素材・化学製品営業（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140304S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140304S/-preBtn__3/':
        '医療機器（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0603S/-preBtn__2/':
        '医療機器メーカー業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0603S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140304S/-preBtn__3/':
        '医療機器（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0603S/-preBtn__2/':
        '医療機器メーカー業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140403S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140403S/-preBtn__3/':
        '医療機器 （品質管理）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__120706S/-preBtn__3/':
        '医療機器品質管理・品質保証（GQP・QMS）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__120706S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140403S/-preBtn__3/':
        '医療機器 （品質管理）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__120706S/-preBtn__3/':
        '医療機器品質管理・品質保証（GQP・QMS）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__010804S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__010804S/-preBtn__3/':
        'MS・医薬品卸営業（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0604S/-preBtn__2/':
        '医薬品卸（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0604S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__010804S/-preBtn__3/':
        'MS・医薬品卸営業（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0604S/-preBtn__2/':
        '医薬品卸（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__010901S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__010901S/-preBtn__3/':
        '食品・飲料営業（国内）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0306S/-preBtn__2/':
        '食品・飲料メーカー（原料含む）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0306S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__010901S/-preBtn__3/':
        '食品・飲料営業（国内）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0306S/-preBtn__2/':
        '食品・飲料メーカー（原料含む）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__010902S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__010902S/-preBtn__3/':
        '日用品・化粧品営業（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0522S/-preBtn__2/':
        '日用品・雑貨 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0522S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__010902S/-preBtn__3/':
        '日用品・化粧品営業（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0522S/-preBtn__2/':
        '日用品・雑貨 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0112M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0112M/-preBtn__3/':
        '広告・メディア営業（職種）',
      '/DodaFront/View/JobSearchList/j_oc__011304S/-preBtn__3/':
        '求人広告営業（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__011304S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0112M/-preBtn__3/':
        '広告・メディア営業（職種）',
      '/DodaFront/View/JobSearchList/j_oc__011304S/-preBtn__3/':
        '求人広告営業（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__011303S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__011303S/-preBtn__3/':
        '人材紹介営業（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1001S/-preBtn__2/':
        '人材紹介・職業紹介（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1001S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__011303S/-preBtn__3/':
        '人材紹介営業（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1001S/-preBtn__2/':
        '人材紹介・職業紹介（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__011402S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__011402S/-preBtn__3/':
        'その他法人営業（既存・ルートセールス中心）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__011202S/-preBtn__3/':
        '広告・メディア法人営業（既存・ルートセールス中心）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__011202S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__011402S/-preBtn__3/':
        'その他法人営業（既存・ルートセールス中心）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__011202S/-preBtn__3/':
        '広告・メディア法人営業（既存・ルートセールス中心）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0210M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0210M/-preBtn__3/': '人事（職種）',
      '/DodaFront/View/JobSearchList/j_oc__110205S/-preBtn__3/':
        '人事アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__110205S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0210M/-preBtn__3/': '人事（職種）',
      '/DodaFront/View/JobSearchList/j_oc__110205S/-preBtn__3/':
        '人事アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__01L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__01L/-preBtn__2/':
        'IT・通信業界（業種）',
      '/DodaFront/View/JobSearchList/j_oc__03L/-preBtn__3/':
        'ITエンジニア（SE・Webエンジニア）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__03L/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__01L/-preBtn__2/':
        'IT・通信業界（業種）',
      '/DodaFront/View/JobSearchList/j_oc__03L/-preBtn__3/':
        'ITエンジニア（SE・Webエンジニア）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__020118S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020118S/-preBtn__3/':
        'Webマーケティング（ネット広告・販促PRなど）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1108S/-preBtn__2/':
        'Webマーケティング（広告代理店・コンサルティング・制作）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1108S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020118S/-preBtn__3/':
        'Webマーケティング（ネット広告・販促PRなど）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1108S/-preBtn__2/':
        'Webマーケティング（広告代理店・コンサルティング・制作）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140406S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140406S/-preBtn__3/':
        '自動車部品・製品（品質管理）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__140310S/-preBtn__3/':
        '自動車部品・製品（アプリケーション）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140310S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140406S/-preBtn__3/':
        '自動車部品・製品（品質管理）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__140310S/-preBtn__3/':
        '自動車部品・製品（アプリケーション）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0530M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0530M/-preBtn__3/':
        '化学系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1508M/-preBtn__3/':
        '食品系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__031501S/-preBtn__3/':
        'IT製品テクニカル・カスタマーサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1208M/-preBtn__3/':
        '医療系技術サポート（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1508M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0530M/-preBtn__3/':
        '化学系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1508M/-preBtn__3/':
        '食品系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__031501S/-preBtn__3/':
        'IT製品テクニカル・カスタマーサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1208M/-preBtn__3/':
        '医療系技術サポート（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__031501S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0530M/-preBtn__3/':
        '化学系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1508M/-preBtn__3/':
        '食品系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__031501S/-preBtn__3/':
        'IT製品テクニカル・カスタマーサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1208M/-preBtn__3/':
        '医療系技術サポート（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1208M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0530M/-preBtn__3/':
        '化学系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1508M/-preBtn__3/':
        '食品系テクニカルサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__031501S/-preBtn__3/':
        'IT製品テクニカル・カスタマーサポート（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1208M/-preBtn__3/':
        '医療系技術サポート（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__011201S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__011201S/-preBtn__3/':
        '広告・メディア法人営業（新規中心）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__011401S/-preBtn__3/':
        'その他法人営業（新規中心）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__011401S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__011201S/-preBtn__3/':
        '広告・メディア法人営業（新規中心）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__011401S/-preBtn__3/':
        'その他法人営業（新規中心）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__020113S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020113S/-preBtn__3/':
        '広告宣伝（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0811M/-preBtn__3/':
        '出版・広告・販促・印刷（職種）',
      '/DodaFront/View/JobSearchList/j_ind__11L/-preBtn__2/':
        'インターネット・広告・メディア業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0811M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020113S/-preBtn__3/':
        '広告宣伝（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0811M/-preBtn__3/':
        '出版・広告・販促・印刷（職種）',
      '/DodaFront/View/JobSearchList/j_ind__11L/-preBtn__2/':
        'インターネット・広告・メディア業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__11L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020113S/-preBtn__3/':
        '広告宣伝（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0811M/-preBtn__3/':
        '出版・広告・販促・印刷（職種）',
      '/DodaFront/View/JobSearchList/j_ind__11L/-preBtn__2/':
        'インターネット・広告・メディア業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__020116S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020116S/-preBtn__3/':
        'MD（企画管理）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__093102S/-preBtn__3/':
        'マーチャンダイザー（販売・サービス）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__093102S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020116S/-preBtn__3/':
        'MD（企画管理）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__093102S/-preBtn__3/':
        'マーチャンダイザー（販売・サービス）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__020311S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020311S/-preBtn__3/': '総務（職種）',
      '/DodaFront/View/JobSearchList/j_oc__110201S/-preBtn__3/':
        '総務アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__110201S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020311S/-preBtn__3/': '総務（職種）',
      '/DodaFront/View/JobSearchList/j_oc__110201S/-preBtn__3/':
        '総務アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__020313S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020313S/-preBtn__3/': '法務（職種）',
      '/DodaFront/View/JobSearchList/j_oc__110202S/-preBtn__3/':
        '法務アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__110202S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020313S/-preBtn__3/': '法務（職種）',
      '/DodaFront/View/JobSearchList/j_oc__110202S/-preBtn__3/':
        '法務アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0204M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0204M/-preBtn__3/':
        '物流管理（企画）・購買・貿易（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1104M/-preBtn__3/':
        '購買・物流・貿易アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1104M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0204M/-preBtn__3/':
        '物流管理（企画）・購買・貿易（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1104M/-preBtn__3/':
        '購買・物流・貿易アシスタント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__020601S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020601S/-preBtn__3/':
        'リサーチャー（データアナリスト）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1304M/-preBtn__3/':
        '金融系リサーチ（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1304M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020601S/-preBtn__3/':
        'リサーチャー（データアナリスト）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1304M/-preBtn__3/':
        '金融系リサーチ（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__020602S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020602S/-preBtn__3/':
        'データサイエンティスト（企画）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__032001S/-preBtn__3/':
        'データアナリスト（技術職）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__032001S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__020602S/-preBtn__3/':
        'データサイエンティスト（企画）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__032001S/-preBtn__3/':
        'データアナリスト（技術職）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__110701S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__110701S/-preBtn__3/':
        '銀行員・証券事務（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0706S/-preBtn__2/':
        '証券会社・ネット証券（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0706S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__110701S/-preBtn__3/':
        '銀行員・証券事務（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0706S/-preBtn__2/':
        '証券会社・ネット証券（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__110702S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__110702S/-preBtn__3/':
        '損保・生保事務（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0708S/-preBtn__2/':
        '損害保険（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0707S/-preBtn__2/':
        '生命保険（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0708S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__110702S/-preBtn__3/':
        '損保・生保事務（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0708S/-preBtn__2/':
        '損害保険（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0707S/-preBtn__2/':
        '生命保険（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0707S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__110702S/-preBtn__3/':
        '損保・生保事務（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0708S/-preBtn__2/':
        '損害保険（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0707S/-preBtn__2/':
        '生命保険（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0311M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0311M/-preBtn__3/':
        'ITコンサルタント・システムコンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0107S/-preBtn__2/':
        'ITコンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0107S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0311M/-preBtn__3/':
        'ITコンサルタント・システムコンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0107S/-preBtn__2/':
        'ITコンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0312M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0312M/-preBtn__3/':
        'プリセールス（ITエンジニア）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1409M/-preBtn__3/':
        'アプリケーションエンジニア（組み込み）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1409M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0312M/-preBtn__3/':
        'プリセールス（ITエンジニア）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1409M/-preBtn__3/':
        'アプリケーションエンジニア（組み込み）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__031411S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__031411S/-preBtn__3/':
        'Webサービスエンジニア（ネットワーク・サーバー・データベース）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__032102S/-preBtn__3/':
        'Webサービス系エンジニア（フロントエンド・サーバーサイド・フルスタック）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__032102S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__031411S/-preBtn__3/':
        'Webサービスエンジニア（ネットワーク・サーバー・データベース）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__032102S/-preBtn__3/':
        'Webサービス系エンジニア（フロントエンド・サーバーサイド・フルスタック）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0322M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0322M/-preBtn__3/':
        'スマホアプリ・ネイティブアプリ系エンジニア（IT）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__140305S/-preBtn__3/':
        'スマホアプリ・ネイティブアプリ系エンジニア（組み込み）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140305S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0322M/-preBtn__3/':
        'スマホアプリ・ネイティブアプリ系エンジニア（IT）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__140305S/-preBtn__3/':
        'スマホアプリ・ネイティブアプリ系エンジニア（組み込み）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140301S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140301S/-preBtn__3/':
        '機械・電子部品（技術職）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0207S/-preBtn__2/':
        '電子部品メーカー（機械・電気業界）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0535S/-preBtn__2/':
        '電子部品商社（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0207S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140301S/-preBtn__3/':
        '機械・電子部品（技術職）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0207S/-preBtn__2/':
        '電子部品メーカー（機械・電気業界）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0535S/-preBtn__2/':
        '電子部品商社（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0535S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140301S/-preBtn__3/':
        '機械・電子部品（技術職）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0207S/-preBtn__2/':
        '電子部品メーカー（機械・電気業界）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0535S/-preBtn__2/':
        '電子部品商社（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140303S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140303S/-preBtn__3/':
        '組み込みソフトウェア（パチンコ・パチスロ・遊戯機器）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__042210S/-preBtn__3/':
        '機械設計（パチンコ・パチスロ・遊戯機器）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__042210S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140303S/-preBtn__3/':
        '組み込みソフトウェア（パチンコ・パチスロ・遊戯機器）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__042210S/-preBtn__3/':
        '機械設計（パチンコ・パチスロ・遊戯機器）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__140307S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140307S/-preBtn__3/':
        '半導体（組み込みソフトウェア）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0208S/-preBtn__2/':
        '半導体メーカー（機械・電気業界）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0507S/-preBtn__2/':
        '半導体 （商社業界）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0208S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140307S/-preBtn__3/':
        '半導体（組み込みソフトウェア）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0208S/-preBtn__2/':
        '半導体メーカー（機械・電気業界）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0507S/-preBtn__2/':
        '半導体 （商社業界）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0507S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__140307S/-preBtn__3/':
        '半導体（組み込みソフトウェア）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0208S/-preBtn__2/':
        '半導体メーカー（機械・電気業界）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0507S/-preBtn__2/':
        '半導体 （商社業界）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__042506S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__042506S/-preBtn__3/':
        '半導体エンジニア（アプリケーションエンジニア）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0444M/-preBtn__3/':
        'プロセスエンジニア（半導体など）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0444M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__042506S/-preBtn__3/':
        '半導体エンジニア（アプリケーションエンジニア）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0444M/-preBtn__3/':
        'プロセスエンジニア（半導体など）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0201S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0201S/-preBtn__2/':
        '産業用装置（工作機械・半導体製造装置・ロボットなど）メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0501S/-preBtn__2/':
        '産業用装置（工作機械・半導体製造装置・ロボットなど）商社（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0501S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0201S/-preBtn__2/':
        '産業用装置（工作機械・半導体製造装置・ロボットなど）メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0501S/-preBtn__2/':
        '産業用装置（工作機械・半導体製造装置・ロボットなど）商社（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0423M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0423M/-preBtn__3/':
        '品質管理・品質保証（機械・電気）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1207M/-preBtn__3/':
        '品質管理・品質保証（医療）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1207M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0423M/-preBtn__3/':
        '品質管理・品質保証（機械・電気）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1207M/-preBtn__3/':
        '品質管理・品質保証（医療）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__06L/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__06L/-preBtn__3/':
        '技術職・専門職（建設・建築・不動産・プラント・工場）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__08L/-preBtn__2/':
        '建設・プラント・不動産業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__08L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__06L/-preBtn__3/':
        '技術職・専門職（建設・建築・不動産・プラント・工場）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__08L/-preBtn__2/':
        '建設・プラント・不動産業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0630M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0630M/-preBtn__3/':
        '不動産運用・管理（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0810S/-preBtn__2/':
        '不動産管理（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0810S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0630M/-preBtn__3/':
        '不動産運用・管理（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0810S/-preBtn__2/':
        '不動産管理（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0622M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0622M/-preBtn__3/':
        '建築設計・積算（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0632M/-preBtn__3/':
        '設備設計・積算（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0632M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0622M/-preBtn__3/':
        '建築設計・積算（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0632M/-preBtn__3/':
        '設備設計・積算（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__062216S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__062216S/-preBtn__3/':
        '住宅リノベーション・リフォーム・インテリア内装設計（職種）',
      '/DodaFront/View/JobSearchList/j_oc__062313S/-preBtn__3/':
        '建築施工管理（リフォーム・住宅内装・インテリア）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0807S/-preBtn__2/':
        'リフォーム・内装・インテリア（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__062313S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__062216S/-preBtn__3/':
        '住宅リノベーション・リフォーム・インテリア内装設計（職種）',
      '/DodaFront/View/JobSearchList/j_oc__062313S/-preBtn__3/':
        '建築施工管理（リフォーム・住宅内装・インテリア）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0807S/-preBtn__2/':
        'リフォーム・内装・インテリア（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0807S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__062216S/-preBtn__3/':
        '住宅リノベーション・リフォーム・インテリア内装設計（職種）',
      '/DodaFront/View/JobSearchList/j_oc__062313S/-preBtn__3/':
        '建築施工管理（リフォーム・住宅内装・インテリア）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0807S/-preBtn__2/':
        'リフォーム・内装・インテリア（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0626M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0626M/-preBtn__3/':
        'プラント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0802S/-preBtn__2/':
        'プラントメーカー・プラントエンジニアリング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0802S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0626M/-preBtn__3/':
        'プラント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0802S/-preBtn__2/':
        'プラントメーカー・プラントエンジニアリング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__062616S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__062616S/-preBtn__3/':
        'メンテナンス（プラント） （職種）',
      '/DodaFront/View/JobSearchList/j_ind__0811S/-preBtn__2/':
        '設備管理・メンテナンス（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0811S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__062616S/-preBtn__3/':
        'メンテナンス（プラント） （職種）',
      '/DodaFront/View/JobSearchList/j_ind__0811S/-preBtn__2/':
        '設備管理・メンテナンス（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0631M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0631M/-preBtn__3/':
        '施設管理（技術系）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0922M/-preBtn__3/':
        '店舗開発・施設管理（職種）',
      '/DodaFront/View/JobSearchList/j_oc__092501S/-preBtn__3/':
        '施設管理・マネジメント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0922M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0631M/-preBtn__3/':
        '施設管理（技術系）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0922M/-preBtn__3/':
        '店舗開発・施設管理（職種）',
      '/DodaFront/View/JobSearchList/j_oc__092501S/-preBtn__3/':
        '施設管理・マネジメント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__092501S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0631M/-preBtn__3/':
        '施設管理（技術系）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0922M/-preBtn__3/':
        '店舗開発・施設管理（職種）',
      '/DodaFront/View/JobSearchList/j_oc__092501S/-preBtn__3/':
        '施設管理・マネジメント（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__081303S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__081303S/-preBtn__3/':
        '映像・芸能関連AP・AD（職種）',
      '/DodaFront/View/JobSearchList/j_oc__082113S/-preBtn__3/':
        'WEB制作アシスタントディレクター（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__082113S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__081303S/-preBtn__3/':
        '映像・芸能関連AP・AD（職種）',
      '/DodaFront/View/JobSearchList/j_oc__082113S/-preBtn__3/':
        'WEB制作アシスタントディレクター（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0518M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0518M/-preBtn__3/':
        '技術営業・アプリケーションエンジニア（化学・素材・化粧品・トイレタリー）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1507M/-preBtn__3/':
        '技術営業・アプリケーションエンジニア（食品・香料・飼料）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__120801S/-preBtn__3/':
        'アプリケーションスペシャリスト・技術営業（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1507M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0518M/-preBtn__3/':
        '技術営業・アプリケーションエンジニア（化学・素材・化粧品・トイレタリー）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1507M/-preBtn__3/':
        '技術営業・アプリケーションエンジニア（食品・香料・飼料）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__120801S/-preBtn__3/':
        'アプリケーションスペシャリスト・技術営業（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__120801S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0518M/-preBtn__3/':
        '技術営業・アプリケーションエンジニア（化学・素材・化粧品・トイレタリー）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1507M/-preBtn__3/':
        '技術営業・アプリケーションエンジニア（食品・香料・飼料）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__120801S/-preBtn__3/':
        'アプリケーションスペシャリスト・技術営業（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__052902S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__052902S/-preBtn__3/':
        '申請・薬事（技術職）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1205M/-preBtn__3/':
        '医療系薬事（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1205M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__052902S/-preBtn__3/':
        '申請・薬事（技術職）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1205M/-preBtn__3/':
        '医療系薬事（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0531M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0531M/-preBtn__3/':
        '製造・生産（化学）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0532M/-preBtn__3/':
        '製造・生産（化粧品・トイレタリー）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0533M/-preBtn__3/':
        '工場長（化学・素材・化粧品・トイレタリー）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0532M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0531M/-preBtn__3/':
        '製造・生産（化学）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0532M/-preBtn__3/':
        '製造・生産（化粧品・トイレタリー）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0533M/-preBtn__3/':
        '工場長（化学・素材・化粧品・トイレタリー）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0533M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0531M/-preBtn__3/':
        '製造・生産（化学）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0532M/-preBtn__3/':
        '製造・生産（化粧品・トイレタリー）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__0533M/-preBtn__3/':
        '工場長（化学・素材・化粧品・トイレタリー）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1509M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__1509M/-preBtn__3/':
        '製造・生産（食品・香料・飼料）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1511M/-preBtn__3/':
        '工場長（食品・香料・飼料）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1511M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__1509M/-preBtn__3/':
        '製造・生産（食品・香料・飼料）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__1511M/-preBtn__3/':
        '工場長（食品・香料・飼料）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__12L/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__12L/-preBtn__3/':
        '医療系専門職（職種）',
      '/DodaFront/View/JobSearchList/j_ind__06L/-preBtn__2/':
        '医薬品・医療機器・ライフサイエンス・医療系サービス（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__06L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__12L/-preBtn__3/':
        '医療系専門職（職種）',
      '/DodaFront/View/JobSearchList/j_ind__06L/-preBtn__2/':
        '医薬品・医療機器・ライフサイエンス・医療系サービス（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__121201S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__121201S/-preBtn__3/':
        '病院長・事務長（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0608S/-preBtn__2/':
        '病院・大学病院・クリニック（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0608S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__121201S/-preBtn__3/':
        '病院長・事務長（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0608S/-preBtn__2/':
        '病院・大学病院・クリニック（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0611S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0611S/-preBtn__2/':
        '調剤薬局・ドラッグストア業界（医療系）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1213S/-preBtn__2/':
        'ドラッグストア・調剤薬局（小売）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1213S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0611S/-preBtn__2/':
        '調剤薬局・ドラッグストア業界（医療系）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1213S/-preBtn__2/':
        'ドラッグストア・調剤薬局（小売）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1214M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__1214M/-preBtn__3/': '福祉（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0615S/-preBtn__2/':
        '介護・福祉関連サービス（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0615S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__1214M/-preBtn__3/': '福祉（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0615S/-preBtn__2/':
        '介護・福祉関連サービス（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__13L/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__13L/-preBtn__3/':
        '金融系専門職（職種）',
      '/DodaFront/View/JobSearchList/j_ind__07L/-preBtn__2/':
        '金融業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__07L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__13L/-preBtn__3/':
        '金融系専門職（職種）',
      '/DodaFront/View/JobSearchList/j_ind__07L/-preBtn__2/':
        '金融業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__07L/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__07L/-preBtn__3/':
        '専門職（コンサルティングファーム・専門事務所・監査法人）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__09L/-preBtn__2/':
        'コンサルティング・リサーチ業界・専門事務所・監査法人・税理士法人（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__09L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__07L/-preBtn__3/':
        '専門職（コンサルティングファーム・専門事務所・監査法人）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__09L/-preBtn__2/':
        'コンサルティング・リサーチ業界・専門事務所・監査法人・税理士法人（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__071101S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071101S/-preBtn__3/':
        '戦略・経営コンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0901S/-preBtn__2/':
        '経営・戦略コンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0901S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071101S/-preBtn__3/':
        '戦略・経営コンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0901S/-preBtn__2/':
        '経営・戦略コンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__071102S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071102S/-preBtn__3/':
        '組織・人事コンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0903S/-preBtn__2/':
        '組織人事コンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0903S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071102S/-preBtn__3/':
        '組織・人事コンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0903S/-preBtn__2/':
        '組織人事コンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__071105S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071105S/-preBtn__3/':
        'リスクコンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0906S/-preBtn__2/':
        'リスクコンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0906S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071105S/-preBtn__3/':
        'リスクコンサルタント（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0906S/-preBtn__2/':
        'リスクコンサルティング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__071507S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071507S/-preBtn__3/':
        '税理士（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0911S/-preBtn__2/':
        '税理士法人（税理士事務所）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0911S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__071507S/-preBtn__3/':
        '税理士（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0911S/-preBtn__2/':
        '税理士法人（税理士事務所）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__092202S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__092202S/-preBtn__3/':
        'エリアマネジャー・SV（販売・サービス）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__092901S/-preBtn__3/':
        'スーパーバイザー（コールセンター）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__092901S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__092202S/-preBtn__3/':
        'エリアマネジャー・SV（販売・サービス）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__092901S/-preBtn__3/':
        'スーパーバイザー（コールセンター）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0923M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0923M/-preBtn__3/':
        '美容系関連職（職種）',
      '/DodaFront/View/JobSearchList/j_ind__17L/-preBtn__2/':
        '理容・美容・エステ業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__17L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0923M/-preBtn__3/':
        '美容系関連職（職種）',
      '/DodaFront/View/JobSearchList/j_ind__17L/-preBtn__2/':
        '理容・美容・エステ業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0924M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0924M/-preBtn__3/':
        'ツアーコンダクター・旅行手配員・添乗員（職種）',
      '/DodaFront/View/JobSearchList/j_ind__15L/-preBtn__2/':
        '旅行・宿泊・レジャー業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__15L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0924M/-preBtn__3/':
        'ツアーコンダクター・旅行手配員・添乗員（職種）',
      '/DodaFront/View/JobSearchList/j_ind__15L/-preBtn__2/':
        '旅行・宿泊・レジャー業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0925M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0925M/-preBtn__3/':
        'ホテルスタッフ・宿泊施設（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1502S/-preBtn__2/':
        'ホテル・旅館・宿泊施設（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1502S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0925M/-preBtn__3/':
        'ホテルスタッフ・宿泊施設（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1502S/-preBtn__2/':
        'ホテル・旅館・宿泊施設（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0927M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0927M/-preBtn__3/':
        '運輸・物流サービス（職種）',
      '/DodaFront/View/JobSearchList/j_ind__13L/-preBtn__2/':
        '運輸・物流業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__13L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0927M/-preBtn__3/':
        '運輸・物流サービス（職種）',
      '/DodaFront/View/JobSearchList/j_ind__13L/-preBtn__2/':
        '運輸・物流業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__092701S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__092701S/-preBtn__3/':
        '道路旅客・貨物運送（ドライバー・運転手・運転士）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1303S/-preBtn__2/':
        '道路貨物運送業（宅配便・トラック運送など）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1303S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__092701S/-preBtn__3/':
        '道路旅客・貨物運送（ドライバー・運転手・運転士）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1303S/-preBtn__2/':
        '道路貨物運送業（宅配便・トラック運送など）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0928M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0928M/-preBtn__3/':
        '警備／清掃／監視／保守（職種）',
      '/DodaFront/View/JobSearchList/j_ind__16L/-preBtn__2/':
        '警備・清掃業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__16L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0928M/-preBtn__3/':
        '警備／清掃／監視／保守（職種）',
      '/DodaFront/View/JobSearchList/j_ind__16L/-preBtn__2/':
        '警備・清掃業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0929M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0929M/-preBtn__3/':
        'テレマーケティング／カスタマーサポート／コールセンター（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1011S/-preBtn__2/':
        'コールセンター（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1011S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0929M/-preBtn__3/':
        'テレマーケティング／カスタマーサポート／コールセンター（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1011S/-preBtn__2/':
        'コールセンター（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__093002S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__093002S/-preBtn__3/':
        '講師・指導員・インストラクター（職種）',
      '/DodaFront/View/JobSearchList/j_oc__101301S/-preBtn__3/':
        '大学講師（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__101301S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__093002S/-preBtn__3/':
        '講師・指導員・インストラクター（職種）',
      '/DodaFront/View/JobSearchList/j_oc__101301S/-preBtn__3/':
        '大学講師（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0930M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0930M/-preBtn__3/':
        '教育／スクール／研修／塾講師／専門学校／英会話学校（職種）',
      '/DodaFront/View/JobSearchList/j_ind__18L/-preBtn__2/':
        '教育業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__18L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0930M/-preBtn__3/':
        '教育／スクール／研修／塾講師／専門学校／英会話学校（職種）',
      '/DodaFront/View/JobSearchList/j_ind__18L/-preBtn__2/':
        '教育業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0932M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0932M/-preBtn__3/':
        'ブライダル・葬祭（職種）',
      '/DodaFront/View/JobSearchList/j_ind__25L/-preBtn__2/':
        '冠婚葬祭業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__25L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0932M/-preBtn__3/':
        'ブライダル・葬祭（職種）',
      '/DodaFront/View/JobSearchList/j_ind__25L/-preBtn__2/':
        '冠婚葬祭業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__082109S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__082109S/-preBtn__3/':
        'Webライター・Web編集（コンテンツ制作）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1109S/-preBtn__2/':
        'Webサービス・Webメディア（EC・ポータル・ソーシャル）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1109S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__082109S/-preBtn__3/':
        'Webライター・Web編集（コンテンツ制作）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1109S/-preBtn__2/':
        'Webサービス・Webメディア（EC・ポータル・ソーシャル）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0817M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0817M/-preBtn__3/':
        'ファッション（アパレル／アクセサリー／テキスタイル）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0316S/-preBtn__2/':
        'ファッション・アパレル・アクセサリーメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1215S/-preBtn__2/':
        'アパレル・アクセサリー 専門店（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0316S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0817M/-preBtn__3/':
        'ファッション（アパレル／アクセサリー／テキスタイル）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0316S/-preBtn__2/':
        'ファッション・アパレル・アクセサリーメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1215S/-preBtn__2/':
        'アパレル・アクセサリー 専門店（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1215S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0817M/-preBtn__3/':
        'ファッション（アパレル／アクセサリー／テキスタイル）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__0316S/-preBtn__2/':
        'ファッション・アパレル・アクセサリーメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1215S/-preBtn__2/':
        'アパレル・アクセサリー 専門店（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__082107S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__082107S/-preBtn__3/':
        'マークアップエンジニア・コーダー・フロントエンドエンジニア（Web・モバイル）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__082206S/-preBtn__3/':
        'マークアップエンジニア・コーダー・フロントエンドエンジニア（ゲーム）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__082206S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__082107S/-preBtn__3/':
        'マークアップエンジニア・コーダー・フロントエンドエンジニア（Web・モバイル）（職種）',
      '/DodaFront/View/JobSearchList/j_oc__082206S/-preBtn__3/':
        'マークアップエンジニア・コーダー・フロントエンドエンジニア（ゲーム）（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__0822M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0822M/-preBtn__3/':
        'ソーシャル・ゲーム（制作・開発）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1114S/-preBtn__2/':
        'ゲーム（オンライン・ソーシャル）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1114S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__0822M/-preBtn__3/':
        'ソーシャル・ゲーム（制作・開発）（職種）',
      '/DodaFront/View/JobSearchList/j_ind__1114S/-preBtn__2/':
        'ゲーム（オンライン・ソーシャル）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__1014M/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__1014M/-preBtn__3/':
        '農業／畜産／酪農（職種）',
      '/DodaFront/View/JobSearchList/j_ind__21L/-preBtn__2/':
        '農林水産・鉱業（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__21L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_oc__1014M/-preBtn__3/':
        '農業／畜産／酪農（職種）',
      '/DodaFront/View/JobSearchList/j_ind__21L/-preBtn__2/':
        '農林水産・鉱業（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0112S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0112S/-preBtn__2/':
        'ITアウトソーシング（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1010S/-preBtn__2/':
        'アウトソーシング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1010S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0112S/-preBtn__2/':
        'ITアウトソーシング（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1010S/-preBtn__2/':
        'アウトソーシング（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1101S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__1101S/-preBtn__2/':
        '総合広告代理店（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1111S/-preBtn__2/':
        '専門広告代理店（雑誌・新聞・交通・屋外・折込など）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0623S/-preBtn__2/':
        '医療広告代理店・出版社・マーケティング・リサーチ（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1111S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__1101S/-preBtn__2/':
        '総合広告代理店（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1111S/-preBtn__2/':
        '専門広告代理店（雑誌・新聞・交通・屋外・折込など）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0623S/-preBtn__2/':
        '医療広告代理店・出版社・マーケティング・リサーチ（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0623S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__1101S/-preBtn__2/':
        '総合広告代理店（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1111S/-preBtn__2/':
        '専門広告代理店（雑誌・新聞・交通・屋外・折込など）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0623S/-preBtn__2/':
        '医療広告代理店・出版社・マーケティング・リサーチ（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__02L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__02L/-preBtn__2/':
        'メーカー（機械・電気）業界（業種）',
      '/DodaFront/View/JobSearchList/j_ind__03L/-preBtn__2/':
        'メーカー（素材・化学・食品・化粧品・その他）業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__03L/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__02L/-preBtn__2/':
        'メーカー（機械・電気）業界（業種）',
      '/DodaFront/View/JobSearchList/j_ind__03L/-preBtn__2/':
        'メーカー（素材・化学・食品・化粧品・その他）業界（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0202S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0202S/-preBtn__2/':
        '機械部品・金型メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0502S/-preBtn__2/':
        '機械部品・金型 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0502S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0202S/-preBtn__2/':
        '機械部品・金型メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0502S/-preBtn__2/':
        '機械部品・金型 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0209S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0209S/-preBtn__2/':
        'アミューズメント・エンタメ・ゲームメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0509S/-preBtn__2/':
        'アミューズメント・遊戯機器 （商社）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1504S/-preBtn__2/':
        'レジャー・アミューズメント（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0509S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0209S/-preBtn__2/':
        'アミューズメント・エンタメ・ゲームメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0509S/-preBtn__2/':
        'アミューズメント・遊戯機器 （商社）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1504S/-preBtn__2/':
        'レジャー・アミューズメント（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__1504S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0209S/-preBtn__2/':
        'アミューズメント・エンタメ・ゲームメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0509S/-preBtn__2/':
        'アミューズメント・遊戯機器 （商社）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__1504S/-preBtn__2/':
        'レジャー・アミューズメント（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0210S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0210S/-preBtn__2/':
        '精密機器・計測機器・光学機器・分析機器メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0510S/-preBtn__2/':
        '計測機器・光学機器・精密機器・分析機器 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0510S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0210S/-preBtn__2/':
        '精密機器・計測機器・光学機器・分析機器メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0510S/-preBtn__2/':
        '計測機器・光学機器・精密機器・分析機器 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0304S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0304S/-preBtn__2/':
        '製紙・パルプメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0544S/-preBtn__2/':
        '紙・パルプ・木材 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0544S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0304S/-preBtn__2/':
        '製紙・パルプメーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0544S/-preBtn__2/':
        '紙・パルプ・木材 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0327S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0327S/-preBtn__2/':
        '住宅設備メーカー（化学系）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0815S/-preBtn__2/':
        '住宅設備（不動産）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0815S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0327S/-preBtn__2/':
        '住宅設備メーカー（化学系）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0815S/-preBtn__2/':
        '住宅設備（不動産）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0329S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0329S/-preBtn__2/':
        'スポーツ・アウトドア・レジャー用品メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0531S/-preBtn__2/':
        'スポーツ・レジャー用品 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0531S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0329S/-preBtn__2/':
        'スポーツ・アウトドア・レジャー用品メーカー（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0531S/-preBtn__2/':
        'スポーツ・レジャー用品 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0330S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0330S/-preBtn__2/':
        '玩具メーカー（ホビー・おもちゃ）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0541S/-preBtn__2/':
        '玩具 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__0541S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__0330S/-preBtn__2/':
        '玩具メーカー（ホビー・おもちゃ）（業種）',
      '/DodaFront/View/JobSearchList/j_ind__0541S/-preBtn__2/':
        '玩具 （商社）（業種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_ind__2502S/-preBtn__2/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__2502S/-preBtn__2/':
        'ブライダル・ウェディング（業種）',
      '/DodaFront/View/JobSearchList/j_oc__093201S/-preBtn__3/':
        'ブライダルコーディネーター・ウェディングプランナー（職種）',
    },
  },
  {
    url: '/DodaFront/View/JobSearchList/j_oc__093201S/-preBtn__3/',
    centralizeLinks: {
      '/DodaFront/View/JobSearchList/j_ind__2502S/-preBtn__2/':
        'ブライダル・ウェディング（業種）',
      '/DodaFront/View/JobSearchList/j_oc__093201S/-preBtn__3/':
        'ブライダルコーディネーター・ウェディングプランナー（職種）',
    },
  },
];
